// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import core from '@bmp-vue/core'
import VueFileAgent from 'vue-file-agent'
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'

const controllers = require.context('@/controllers', true, /\.js$/)
const paths = require('@/plugins/router/paths').default
const theme = require('@/plugins/vuetify/theme').default

const themeOverrides = {
  themes: {
    light: {
      primary: '#1a1883'
    }
  }
}

const App = () => import('./App')

Vue.use(VueFileAgent)
Vue.use(VueFileAgentStyles)
Vue.use(core, {
  controllers,
  paths,
  theme:
  {
    ...theme,
    ...themeOverrides
  },
  carregaEnums: false,
  extendRouterBeforeEach: (app, to) => to.path !== '/auth/callback',
  mount: (options) => {
    new Vue({
      ...options,
      render: h => h(App)
    }).$mount('#app')
  }
})
